import * as yup from 'yup';
import { TypeOptions } from './Create.conf';
import { API as usersNauticaAPI } from '../../users_nautica/api';

import dayjs from 'dayjs';

export const PriorityOptions = [
    { label: 'URGENT', id: 'URGENT' },
    { label: 'MEDIUM', id: 'MEDIUM' },
    { label: 'LOW', id: 'LOW' },
];

export const StatusOptions = [
    { label: 'OPEN', id: 'OPEN' },
    { label: 'CLOSED', id: 'CLOSED' },
];

export const UpdateConf = {
    schema: yup.object({
        type: yup.object().nullable().required('Type is required'),
        priority: yup.object().nullable().required('Priority is required'),
        status: yup.object().nullable().required('Status is required'),
        assignee_user_id: yup.mixed().nullable(),
        title: yup
            .string()
            .max(255, 'Title is too long (max 255 characters)')
            .required('Ticket Title is required'),
        description: yup.string().required('Ticket Description is required'),
        comment: yup.string().nullable(),
        date: yup.string().nullable()
            .test(
                "valid-date",
                "Invalid date",
                (value) => {
                    if (!value) return true;
                    return dayjs(value).isValid();
                }
            ),
    }),

    fields: [
        {
            id: 'assignee_user_id',
            name: 'assignee_user_id',
            type: 'async_autocomplete',
            label: 'Assignee',
            api: usersNauticaAPI.selectName,
            xs: 12,
            sm: 6,
            md: 4,
        },
        {
            id: 'title',
            name: 'title',
            type: 'text',
            label: 'Title',
            required: true,
            xs: 12,
        },
        {
            id: 'description',
            name: 'description',
            type: 'text_multiline',
            label: 'Description',
            required: true,
            xs: 12,
            rows: 10,
        },
        {
            id: 'type',
            name: 'type',
            type: 'autocomplete',
            label: 'Type',
            options: TypeOptions,
            required: true,
            xs: 12,
            sm: 6,
        },
        {
            id: 'priority',
            name: 'priority',
            type: 'autocomplete',
            label: 'Priority',
            options: PriorityOptions,
            required: true,
            xs: 12,
            sm: 6,
        },
        {
            id: 'status',
            name: 'status',
            type: 'autocomplete',
            label: 'Status',
            options: StatusOptions,
            required: true,
            xs: 12,
            sm: 6,
        },
        {
            id: 'date',
            name: 'date',
            type: 'date',
            label: 'Date',
            required: false,
            xs: 12,
            sm: 6,
        },
    ],

    defaultValues: {
        assignee_user_id: null,
        title: '',
        description: '',
        type: { label: 'PROGRAMMA BARCA', id: 'PROGRAMMA BARCA' },
        priority: { label: 'MEDIUM', id: 'MEDIUM' },
        status: { label: 'OPEN', id: 'OPEN' },
        comment: '',
        date: null,
    },
};